module.exports = __webpack_public_path__ + "img/search-status.f0c6e65f.svg";